var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"flex flex-center preview-rotate",on:{"click":function($event){$event.stopPropagation();return _vm.handleChangeRoate.apply(null, arguments)}}},[_c('Icon',{attrs:{"path":"preview","name":"rotate"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }